import { TokenService } from '../application/services/TokenService';
import { setContext } from '@apollo/client/link/context';
import { getCorrelationIdFromStorage } from './utils/correlationIdUtils';

/**
 * Creates an Apollo auth link that adds the authentication token and correlationId to GraphQL requests
 * @param tokenService The token service to use for retrieving the token
 * @returns Apollo auth link middleware
 */
export const createApolloAuthLink = (tokenService: TokenService) => {
  return setContext((_, { headers }) => {
    const token = tokenService.getToken();
    const correlationId = getCorrelationIdFromStorage();

    return {
      headers: {
        ...headers,
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(correlationId && { 'X-correlation-ID': correlationId })
      }
    };
  });
};
